import React, { useState, useEffect } from 'react'
// import ReactBodymovin from 'react-bodymovin'
import animation from './bye.json'
import BodyMovin from '../BodyMovin.js';
import './_animation.scss';


const ByeAni = () => {
  const [isPlay, setPlay] = useState(false);

  const bodymovinOptions = {
    loop: true,
    autoplay: true,
    prerender: true,
    animationData: animation
  }

  useEffect(() => {
    const timer = setTimeout(() => { setPlay(true) }, 500);
    return () => clearTimeout(timer);
  }, []);

  // 1초 정도 위에
  return (
    <>
      {
        isPlay &&
        <div className="bye">
          <BodyMovin className="byeing" options={bodymovinOptions} />
        </div>
      }
    </>
  )
}

export default ByeAni;
